import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0e608ebd"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0e608ebd&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e608ebd')) {
      api.createRecord('0e608ebd', component.options)
    } else {
      api.reload('0e608ebd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0e608ebd", function () {
      api.rerender('0e608ebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openjobs/index.vue"
export default component.exports